import React, { Component } from "react";
import "../../assets/css/RecipientList.css";
import "../../assets/css/header.css";
import "../../routes/app";

import { fire, auth } from "../../firebase/index";
import NoDataFound from "../Errors/NoDataFound";
import Loading from "../../components/Loading/Loading";
import withAuthorization from "../../components/Authorization/withAuthorization";
import AddRecipient from "../Tutorial/AddRecipientGuide";
import Add from "../RecipientManagement/Add";

import {
  BootstrapTable,
  TableHeaderColumn,
  SearchField,
  SizePerPageDropDown,
  ExportCSVButton,
} from "react-bootstrap-table";
import { Button, Modal } from "react-bootstrap";

import NotificationSystem from "react-notification-system";
import { confirmAlert } from "react-confirm-alert";
import { ExportToCsv } from "export-to-csv";
import LocalizedStrings from "react-localization";

import { style, customLog } from "../../variables/Variables";

const localizationStrings = new LocalizedStrings({
  en: {
    recipientTitle: "Recipient Management",
    descriptionTitle: "Add users for access sharing",
    doubleClickInstruc: "Double-click nickname to edit",
    memberNameTitle: "Member Name",
    headerName: "Nickname",
    headerEmail: "Email",
    resultTitle1: "Showing ",
    resultTitle2: " to ",
    resultTitle3: " of ",
    resultTitle4: " Results",
    nextPage: "First Page",
    prePage: "Pre page",
    firstPage: "Next page",
    lastPage: "Last page",
    removeSelectedBtn: "Remove Selected",
    addRecipientGuide: "Add Recipient",
    searchPlaceholder: "Search",
    noDataTitle: "There is no data to display",
    confirmRemoveTitle: "Confirm recipient removal",
    removeRecipientTitle: "Remove recipient?",
    confirmTitle: "Confirm",
    cancelTitle: "Cancel",
    usernameInvalid: "Invalid user name, please try again.",
    userDeleted: "Users have been deleted successfully!",
    usernameChanged: "Username has been changed!",
    usernameError: "Unable to change username!",
    errorEmptyTitle: "Nickname cannot be empty.",
    errorCharacterLimitTitle: "Characters for name have exceeded the limit.",
    errorSameNameTitle:
      "Nickname cannot be the same as the user's current name or another member's name.",
    successUpdateTitle: "Updated nickname successfully.",
    exportCSVTitle: "Export CSV",
    exportRecipientsHeader: "Export Recipients",
    exportBtn: "Export",
    cancelBtn: "Cancel",
  },
  ja: {
    recipientTitle: "メンバー管理",
    descriptionTitle: "アクセス共有のためにユーザーを追加する",
    doubleClickInstruc: "名前の変更は該当欄をダブルクリックします",
    memberNameTitle: "名前",
    headerName: "名前-2",
    headerEmail: "Eメール",
    resultTitle1: "表示 ",
    resultTitle2: " へ",
    resultTitle3: " の ",
    resultTitle4: " 結果",
    nextPage: "先頭ページ",
    prePage: "前ページ",
    firstPage: "次のページ",
    lastPage: "最後のページ",
    removeSelectedBtn: "削除",
    addRecipientGuide: "受信者を追加する",
    searchPlaceholder: "検索",
    noDataTitle: "表示するデータがありません。",
    confirmRemoveTitle: "受信者の削除を確認する",
    removeRecipientTitle: "メンバーのアクセスを無効にしますか？",
    confirmTitle: "OK",
    cancelTitle: "キャンセル",
    usernameInvalid: "名称が無効です。再入力して下さい。",
    userDeleted: "ユーザーは正常に削除されました。",
    usernameChanged: "名称を変更しました。",
    usernameError: "メンバー名称を変更できません。",
    errorEmptyTitle: "名称を入力して下さい。",
    errorCharacterLimitTitle: "名称が制限文字数を超えています。",
    errorSameNameTitle:
      "新しい名称で登録して下さい。一度使用した名称は登録できません。",
    successUpdateTitle: "名称を変更しました。",
    exportCSVTitle: "CSV出力",
    exportRecipientsHeader: "受取人のエクスポート",
    exportBtn: "エクスポート",
    cancelBtn: "キャンセル",
  },
  es: {
    recipientTitle: "Gestión de Destinatarios",
    descriptionTitle: "Agregar usuarios para compartir acceso",
    doubleClickInstruc: "Haz doble clic en el nombre para editar",
    memberNameTitle: "Nombre del miembro",
    headerName: "Apodo",
    headerEmail: "Correo Electrónico",
    resultTitle1: "Mostrando ",
    resultTitle2: " a ",
    resultTitle3: " de ",
    resultTitle4: " Resultados",
    nextPage: "Primera Página",
    prePage: "Página Anterior",
    firstPage: "Página Siguiente",
    lastPage: "Última Página",
    removeSelectedBtn: "Eliminar Seleccionados",
    addRecipientGuide: "Agregar Destinatario",
    searchPlaceholder: "Buscar",
    noDataTitle: "No hay datos para mostrar",
    confirmRemoveTitle: "Confirmar la eliminación del destinatario",
    removeRecipientTitle: "¿Eliminar destinatario?",
    confirmTitle: "Confirmar",
    cancelTitle: "Cancelar",
    usernameInvalid:
      "Nombre de usuario inválido, por favor intenta nuevamente.",
    userDeleted: "¡Los usuarios han sido eliminados exitosamente!",
    usernameChanged: "¡El nombre de usuario ha sido cambiado!",
    usernameError: "¡No se puede cambiar el nombre de usuario!",
    errorEmptyTitle: "El nombre no puede estar vacío.",
    errorCharacterLimitTitle:
      "Los caracteres para el nombre han superado el límite.",
    errorSameNameTitle:
      "El nombre no puede ser el mismo que el nombre actual del usuario o el nombre de otro miembro.",
    successUpdateTitle: "Nombre actualizado con éxito.",
    exportCSVTitle: "Exportar CSV",
    exportRecipientsHeader: "Exportar Destinatarios",
    exportBtn: "Exportar",
    cancelBtn: "Cancelar",
  },
});

const NAME_REGEX = /^[a-zA-Z0-9 _\-一-龠ぁ-ゔァ-ヴーａ-ｚＡ-Ｚ０-９々〆〤]+$/;

const buildRecipientDeleteMessage = (rowKeys = [], recipients = []) => {
  const lines = [];
  let count = 0;

  for (let i = 0; i < recipients.length; i++) {
    const recipient = recipients[i];

    if (rowKeys.includes(recipient.id)) {
      const memberName = recipient.memberName || "-";
      const nickname = recipient.friendName || "-";
      const email = recipient.friendEmail || "-";

      lines.push(`${count + 1}. ${nickname} <${email}>`);

      count += 1;
      if (count === 5) break;
    }
  }

  const total = rowKeys.length;

  return (
    <div>
      <div>
        You are about to remove <strong>{total}</strong> selected recipient
        {total > 1 ? "s" : ""}.
      </div>

      <div style={{ marginTop: "10px", marginBottom: "10px" }}>
        {lines.map((line, index) => (
          <div key={index}>{line}</div>
        ))}

        {total > 5 && (
          <div style={{ marginTop: "8px", fontStyle: "italic" }}>
            ...and {total - 5} more.
          </div>
        )}
      </div>

      <div>{localizationStrings.removeRecipientTitle}</div>
    </div>
  );
};

const customConfirmDialog = (next, rowKeys, recipients = []) => {
  confirmAlert({
    title: `${localizationStrings.confirmRemoveTitle} (${rowKeys.length})`,
    message: buildRecipientDeleteMessage(rowKeys, recipients),
    buttons: [
      {
        label: localizationStrings.confirmTitle,
        onClick: () => next(),
      },
      {
        label: localizationStrings.cancelTitle,
        onClick: () => false,
      },
    ],
  });
};

class RecipientManagement extends Component {
  state = {
    userFriendList: [],
    userFriendListLength: 0,
    loading: true,
    currentLanguage: "en",
    showPopup: false,
    popupTitle: "",
    popupImage: [],
    showExportPopup: false,
    selectedRecipients: [],
  };

  componentDidMount() {
    this.notificationSystem = this.refs.notificationSystem;
    this.subscribeToLanguage();
    this.getUserFriendList();
  }

  componentWillUnmount() {
    if (this.languageRef) {
      this.languageRef.off();
    }
  }

  subscribeToLanguage = () => {
    if (!auth.currentUser) return;

    this.languageRef = fire
      .database()
      .ref(`userSettings/${auth.currentUser.uid}/language`);

    this.languageRef.on("value", (snapshot) => {
      const currentLanguage = snapshot.val() || "en";
      localizationStrings.setLanguage(currentLanguage);
      this.setState({ currentLanguage });
    });
  };

  showNotification = (
    msg,
    level = "info",
    position = "tc",
    autoDismiss = 3,
  ) => {
    if (!this.notificationSystem) return;

    this.notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-bell" />,
      message: <div>{msg}</div>,
      level,
      position,
      autoDismiss,
    });
  };

  normalizeEmail = (email = "") => email.toLowerCase().trim();

  sanitizeNickname = (value) =>
    String(value || "")
      .trim()
      .replace(/[^a-zA-Z0-9_]/g, "");

  getUserFriendList = async () => {
    try {
      const uid = auth.currentUser?.uid;
      if (!uid) return;

      const friendListRef = fire
        .database()
        .ref(`userFriendListIndustrial/${uid}`);

      const groupAccountsRef = fire.database().ref("groupAccounts");

      const [friendSnapshot, groupSnapshot] = await Promise.all([
        friendListRef.orderByKey().once("value"),
        groupAccountsRef.once("value"),
      ]);

      if (!friendSnapshot.exists()) {
        this.setState({
          userFriendList: [],
          userFriendListLength: 0,
          loading: false,
          selectedRecipients: [],
        });
        return;
      }

      const friends = [];
      const emailToFriendMap = new Map();
      const validEmails = new Set();

      friendSnapshot.forEach((item) => {
        const value = item.val();
        const normalizedEmail = this.normalizeEmail(value.friendEmail);

        const friend = {
          ...value,
          id: item.key,
          memberName: "N/A",
        };

        friends.push(friend);
        emailToFriendMap.set(normalizedEmail, friend);
      });

      if (groupSnapshot.exists()) {
        groupSnapshot.forEach((superAdmin) => {
          const members = superAdmin.val()?.members || {};
          Object.values(members).forEach((member) => {
            const normalizedMemberEmail = this.normalizeEmail(
              member.memberEmail,
            );
            validEmails.add(normalizedMemberEmail);

            if (emailToFriendMap.has(normalizedMemberEmail)) {
              emailToFriendMap.get(normalizedMemberEmail).memberName =
                member.memberName || "N/A";
            }
          });
        });
      }

      const invalidFriends = friends.filter(
        (friend) => !validEmails.has(this.normalizeEmail(friend.friendEmail)),
      );

      await Promise.all(
        invalidFriends.map((friend) =>
          fire
            .database()
            .ref(`userFriendListIndustrial/${uid}/${friend.id}`)
            .remove(),
        ),
      );

      const cleanedFriends = friends.filter((friend) =>
        validEmails.has(this.normalizeEmail(friend.friendEmail)),
      );

      this.setState({
        userFriendList: cleanedFriends,
        userFriendListLength: cleanedFriends.length,
        loading: false,
        selectedRecipients: [],
      });
    } catch (error) {
      customLog("Error fetching user friend list:", error);
      this.setState({ loading: false });
    }
  };

  updateTable = (data) => {
    this.setState((prevState) => {
      const userFriendList = [...prevState.userFriendList, data];
      return {
        userFriendList,
        userFriendListLength: userFriendList.length,
      };
    });
  };

  beforeSaveCell = (row, cellName, cellValue) => {
    if (row.friendName === cellValue) return false;

    if (!NAME_REGEX.test(cellValue)) {
      this.showNotification(localizationStrings.usernameInvalid, "error");
      return false;
    }

    return true;
  };

  onAfterSaveCell = async (row, cellName, cellValue) => {
    try {
      const uid = auth.currentUser?.uid;
      if (!uid) return;

      const recipientEmail = this.normalizeEmail(row.friendEmail);
      const sanitizedCellValue = this.sanitizeNickname(cellValue);

      if (!sanitizedCellValue) {
        this.showNotification(localizationStrings.errorEmptyTitle, "error");
        return this.getUserFriendList();
      }

      if (sanitizedCellValue.length >= 61) {
        this.showNotification(
          localizationStrings.errorCharacterLimitTitle,
          "error",
        );
        return this.getUserFriendList();
      }

      const snapshot = await fire
        .database()
        .ref(`userFriendListIndustrial/${uid}`)
        .once("value");

      let duplicateExists = false;
      let targetId = null;
      let currentName = "";

      snapshot.forEach((friend) => {
        const value = friend.val();
        const normalizedEmail = this.normalizeEmail(value.friendEmail);

        if (
          value.friendName === sanitizedCellValue &&
          normalizedEmail !== recipientEmail
        ) {
          duplicateExists = true;
        }

        if (normalizedEmail === recipientEmail) {
          targetId = friend.key;
          currentName = value.friendName;
        }
      });

      if (duplicateExists) {
        this.showNotification(localizationStrings.errorSameNameTitle, "error");
        return this.getUserFriendList();
      }

      if (!targetId) {
        this.showNotification(localizationStrings.usernameError, "error");
        return this.getUserFriendList();
      }

      if (currentName === sanitizedCellValue) {
        return;
      }

      await fire
        .database()
        .ref(`userFriendListIndustrial/${uid}/${targetId}`)
        .update({
          friendName: sanitizedCellValue,
        });

      this.showNotification(localizationStrings.successUpdateTitle, "success");
      this.getUserFriendList();
    } catch (error) {
      customLog("Error saving cell:", error);
      this.showNotification(localizationStrings.usernameError, "error");
      this.getUserFriendList();
    }
  };

  onAfterDeleteRow = async (rowKeys) => {
    try {
      const uid = auth.currentUser?.uid;
      if (!uid || !rowKeys?.length) return;

      const db = fire.database();

      for (const rowKey of rowKeys) {
        const friendSnap = await db
          .ref(`userFriendListIndustrial/${uid}/${rowKey}`)
          .once("value");

        if (!friendSnap.exists()) continue;

        const friend = friendSnap.val();
        const emailOfUser = friend.friendEmail;
        const nameOfUser = friend.friendName;

        await Promise.all([
          db.ref(`userFriendListIndustrial/${uid}/${rowKey}`).remove(),
          db.ref(`userFriendList/${uid}/${nameOfUser}`).remove(),
        ]);

        const [historySnap, retractableSnap] = await Promise.all([
          db.ref(`historicalRecipients/${uid}`).once("value"),
          db.ref(`retractableSharingRegistry/${uid}`).once("value"),
        ]);

        const historyUpdates = [];
        const retractableDeletes = [];

        if (historySnap.exists()) {
          historySnap.forEach((historyItem) => {
            const historyVal = historyItem.val();
            if (historyVal.email === emailOfUser) {
              historyUpdates.push(
                db
                  .ref(`historicalRecipients/${uid}/${historyItem.key}`)
                  .update({
                    status: "Deleted from Recipient Management",
                  }),
              );
            }
          });
        }

        if (retractableSnap.exists()) {
          retractableSnap.forEach((item) => {
            const details = item.val();
            if (details.sharedToEmail === emailOfUser) {
              retractableDeletes.push(
                db
                  .ref(`retractableSharingRegistry/${uid}/${item.key}`)
                  .remove(),
              );
            }
          });
        }

        await Promise.all([...historyUpdates, ...retractableDeletes]);
      }

      this.showNotification(
        localizationStrings.userDeleted,
        "success",
        "tc",
        5,
      );
      this.getUserFriendList();
    } catch (error) {
      customLog("Error deleting rows:", error);
      this.showNotification("Failed to delete recipients.", "error");
    }
  };

  handleExportCSVButtonClick = () => {
    this.setState({ showExportPopup: true });
  };

  handleExportCSV = async () => {
    const { userFriendList } = this.state;

    if (!userFriendList.length) {
      this.showNotification("No recipients to export!", "error");
      return;
    }

    const data = userFriendList.map((recipient) => ({
      [localizationStrings.memberNameTitle]: recipient.memberName,
      [localizationStrings.headerName]: recipient.friendName,
      [localizationStrings.headerEmail]: recipient.friendEmail,
    }));

    const csvExporter = new ExportToCsv({
      filename: `${auth.currentUser.email}_recipients_list`,
      showTitle: true,
      title: `${auth.currentUser.email} Recipients`,
      useTextFile: false,
      showLabels: true,
      useBom: true,
      quoteStrings: false,
      headers: [
        localizationStrings.memberNameTitle,
        localizationStrings.headerName,
        localizationStrings.headerEmail,
      ],
    });

    csvExporter.generateCsv(data);
    this.setState({ showExportPopup: false });
  };

  handlePopupOpen = () => {
    this.setState({
      showPopup: true,
      popupTitle: localizationStrings.addRecipientGuide,
      popupImage: [<AddRecipient key="add-recipient-guide" />],
    });
  };

  handlePopupClose = () => {
    this.setState({
      showPopup: false,
      showExportPopup: false,
    });
  };

  createCustomDeleteButton = (onClick) => (
    <Button
      bsSize="large"
      id="recipientDeleteBtn"
      onClick={onClick}
      style={{ marginTop: "10px", width: "147px" }}
    >
      <i className="far fa-trash-alt" /> {localizationStrings.removeSelectedBtn}
    </Button>
  );

  createCustomExportCSVButton = (onClick) => (
    <ExportCSVButton
      btnText={localizationStrings.exportCSVTitle}
      className="exportCSVBtn"
      onClick={() => this.handleExportCSVButtonClick(onClick)}
    />
  );

  createCustomSearchField = () => (
    <SearchField
      className="searchBar"
      placeholder={localizationStrings.searchPlaceholder}
    />
  );

  onToggleDropDown = (toggleDropDown) => toggleDropDown();

  renderSizePerPageDropDown = (props) => (
    <SizePerPageDropDown
      variation="dropup"
      onClick={() => this.onToggleDropDown(props.toggleDropDown)}
      {...props}
    />
  );

  loadingData = () => {
    if (this.state.loading) {
      return (
        <div style={{ textAlign: "center" }}>
          <Loading />
        </div>
      );
    }

    return (
      <div style={{ textAlign: "center" }}>
        <NoDataFound />
      </div>
    );
  };

  getSelectRowProp = () => {
    const { selectedRecipients, userFriendList } = this.state;

    return {
      bgColor: "#eeeeee",
      mode: "checkbox",
      clickToSelect: true,
      selected: selectedRecipients,
      onSelect: (row, isSelected) => {
        this.setState((prevState) => ({
          selectedRecipients: isSelected
            ? [...prevState.selectedRecipients, row.id]
            : prevState.selectedRecipients.filter((id) => id !== row.id),
        }));
      },
      onSelectAll: (isSelected) => ({
        selectedRecipients: isSelected
          ? userFriendList.map((row) => row.id)
          : [],
      }),
    };
  };

  getTableOptions = () => {
    const customTotal = (from, to, size) => (
      <span
        className="react-bootstrap-table-pagination-total"
        style={{ float: "right" }}
      >
        {localizationStrings.resultTitle1}
        {from}
        {localizationStrings.resultTitle2}
        {to}
        {localizationStrings.resultTitle3}
        {size}
        {localizationStrings.resultTitle4}
      </span>
    );

    return {
      afterDeleteRow: this.onAfterDeleteRow,
      handleConfirmDeleteRow: (next, rowKeys) =>
        customConfirmDialog(next, rowKeys, this.state.userFriendList),
      page: 1,
      sizePerPageList: [
        { text: "10", value: 10 },
        { text: "50", value: 50 },
        { text: "100", value: 100 },
        { text: "All", value: this.state.userFriendListLength || 10 },
      ],
      sizePerPage: 10,
      pageStartIndex: 1,
      paginationSize: 10,
      prePage: "<",
      nextPage: ">",
      firstPage: "<<",
      lastPage: ">>",
      paginationShowsTotal: customTotal,
      noDataText: this.loadingData(),
      searchField: this.createCustomSearchField,
      deleteBtn: this.createCustomDeleteButton,
      exportCSVBtn: this.createCustomExportCSVButton,
    };
  };

  render() {
    localizationStrings.setLanguage(this.state.currentLanguage || "en");

    const cellEditProp = {
      mode: "dbclick",
      blurToSave: true,
      afterSaveCell: this.onAfterSaveCell,
      beforeSaveCell: this.beforeSaveCell,
    };

    const columnHover = (cell) => cell;

    return (
      <div
        className="header"
        style={{ maxWidth: "95%", margin: "auto", marginBottom: "10px" }}
      >
        <NotificationSystem ref="notificationSystem" style={style} />

        <h4>{localizationStrings.descriptionTitle}</h4>
        <h6 className="instructionStyle" style={{ marginBottom: "30px" }}>
          {localizationStrings.doubleClickInstruc}
        </h6>

        <BootstrapTable
          id="table"
          pagination
          search
          bordered={false}
          data={this.state.userFriendList}
          selectRow={this.getSelectRowProp()}
          deleteRow
          exportCSV
          options={this.getTableOptions()}
          cellEdit={cellEditProp}
        >
          <TableHeaderColumn dataSort dataField="id" isKey hidden />
          <TableHeaderColumn
            dataSort
            dataField="memberName"
            editable={false}
            columnTitle={columnHover}
          >
            {localizationStrings.memberNameTitle}
          </TableHeaderColumn>
          <TableHeaderColumn
            dataSort
            dataField="friendName"
            editable
            columnTitle={columnHover}
          >
            {localizationStrings.headerName}
          </TableHeaderColumn>
          <TableHeaderColumn
            dataSort
            dataField="friendEmail"
            editable={false}
            columnTitle={columnHover}
          >
            {localizationStrings.headerEmail}
          </TableHeaderColumn>
        </BootstrapTable>

        <br />
        <Add dataCallBack={this.updateTable} />
        <br />

        <Modal
          show={this.state.showPopup}
          onHide={this.handlePopupClose}
          dialogClassName="modal-90w"
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.state.popupTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{this.state.popupImage}</Modal.Body>
        </Modal>

        <Modal
          show={this.state.showExportPopup}
          onHide={this.handlePopupClose}
          dialogClassName="modal-90w"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {localizationStrings.exportRecipientsHeader}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <BootstrapTable
              id="export-table"
              pagination
              bordered={false}
              data={this.state.userFriendList}
              options={{
                paginationSize: 10,
                hideSizePerPage: true,
                noDataText: localizationStrings.noDataTitle,
              }}
            >
              <TableHeaderColumn dataSort dataField="id" isKey hidden />
              <TableHeaderColumn
                dataSort
                dataField="memberName"
                editable={false}
                columnTitle={columnHover}
              >
                {localizationStrings.memberNameTitle}
              </TableHeaderColumn>
              <TableHeaderColumn
                dataSort
                dataField="friendName"
                editable={false}
                columnTitle={columnHover}
              >
                {localizationStrings.headerName}
              </TableHeaderColumn>
              <TableHeaderColumn
                dataSort
                dataField="friendEmail"
                editable={false}
                columnTitle={columnHover}
              >
                {localizationStrings.headerEmail}
              </TableHeaderColumn>
            </BootstrapTable>

            <div
              className="exportCSVpopupButtons"
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <button className="exportButton" onClick={this.handleExportCSV}>
                {localizationStrings.exportBtn}
              </button>
              <button className="cancelButton" onClick={this.handlePopupClose}>
                {localizationStrings.cancelBtn}
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

const authCondition = (authUser) => !!authUser;
export default withAuthorization(authCondition)(RecipientManagement);
